// assets/product-form.js (COMPLETO) - con límite por stock para NO personalizables + bloqueo visual real del "+"

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        if (!this.form) return;

        this.variantIdInput = this.form.querySelector("[name=id]");
        if (this.variantIdInput) this.variantIdInput.disabled = false;

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

        this.cartNotification = document.querySelector("cart-notification");
        this.cartDrawer = document.querySelector("cart-drawer");

        this.productInfoEl = this.closest("product-info");
        this.sectionId =
          (this.productInfoEl &&
            (this.productInfoEl.dataset.originalSection || this.productInfoEl.dataset.section)) ||
          this.dataset.sectionId ||
          null;

        this.quantityInput = this.sectionId
          ? document.getElementById("Quantity-" + this.sectionId)
          : this.querySelector(".quantity__input");

        this.plusBtn = null;
        this.minusBtn = null;

        if (this.sectionId) {
          var qtyForm = document.getElementById("Quantity-Form-" + this.sectionId);
          if (qtyForm) {
            this.plusBtn = qtyForm.querySelector('button.quantity__button[name="plus"]');
            this.minusBtn = qtyForm.querySelector('button.quantity__button[name="minus"]');
          }
        } else {
          this.plusBtn = this.querySelector('button.quantity__button[name="plus"]');
          this.minusBtn = this.querySelector('button.quantity__button[name="minus"]');
        }

        this._onAnyQtyChange = this._onAnyQtyChange.bind(this);
        this._onVariantMaybeChanged = this._onVariantMaybeChanged.bind(this);

        this.ensureDisabledButtonStyles();
        this.applyStockLimitAndUi();

        document.addEventListener("variant:change", this._onVariantMaybeChanged);

        if (this.variantIdInput) {
          this.variantIdInput.addEventListener("change", this._onVariantMaybeChanged);
        }

        if (this.quantityInput) {
          this.quantityInput.addEventListener("input", this._onAnyQtyChange);
          this.quantityInput.addEventListener("change", this._onAnyQtyChange);
        }
      }

      disconnectedCallback() {
        document.removeEventListener("variant:change", this._onVariantMaybeChanged);

        if (this.variantIdInput) {
          this.variantIdInput.removeEventListener("change", this._onVariantMaybeChanged);
        }

        if (this.quantityInput) {
          this.quantityInput.removeEventListener("input", this._onAnyQtyChange);
          this.quantityInput.removeEventListener("change", this._onAnyQtyChange);
        }
      }

      ensureDisabledButtonStyles() {
        if (document.getElementById("qty-btn-disabled-style")) return;

        var style = document.createElement("style");
        style.id = "qty-btn-disabled-style";
        style.textContent = `
          button.quantity__button.is-disabled {
            opacity: 0.45;
            cursor: not-allowed !important;
          }
          button.quantity__button.is-disabled .svg-wrapper,
          button.quantity__button.is-disabled svg {
            opacity: 0.7;
          }
        `;
        document.head.appendChild(style);
      }

      toggleAddButton(enable = true, text) {
        this.toggleSubmitButton(!enable, text);
      }

      toggleSubmitButton(disabled = true, text) {
        var submitButton = this.querySelector('[type="submit"]');
        if (!submitButton) return;

        submitButton.disabled = !!disabled;

        if (disabled) {
          submitButton.setAttribute("aria-disabled", "true");
        } else {
          submitButton.removeAttribute("aria-disabled");
        }

        if (text) {
          var submitText = submitButton.querySelector("span");
          if (submitText) submitText.textContent = text;
          else submitButton.textContent = text;
        }
      }

      _onVariantMaybeChanged() {
        this.refreshRefs();
        this.applyStockLimitAndUi();
      }

      _onAnyQtyChange() {
        this.applyStockLimitAndUi();
      }

      refreshRefs() {
        this.productInfoEl = this.closest("product-info");
        this.sectionId =
          (this.productInfoEl &&
            (this.productInfoEl.dataset.originalSection || this.productInfoEl.dataset.section)) ||
          this.dataset.sectionId ||
          this.sectionId ||
          null;

        this.quantityInput = this.sectionId
          ? document.getElementById("Quantity-" + this.sectionId)
          : this.querySelector(".quantity__input");

        this.plusBtn = null;
        this.minusBtn = null;

        if (this.sectionId) {
          var qtyForm = document.getElementById("Quantity-Form-" + this.sectionId);
          if (qtyForm) {
            this.plusBtn = qtyForm.querySelector('button.quantity__button[name="plus"]');
            this.minusBtn = qtyForm.querySelector('button.quantity__button[name="minus"]');
          }
        } else {
          this.plusBtn = this.querySelector('button.quantity__button[name="plus"]');
          this.minusBtn = this.querySelector('button.quantity__button[name="minus"]');
        }
      }

      isCustomizableProduct() {
        if (!this.productInfoEl) return false;
        return (this.productInfoEl.dataset.fabricado || "").toString() === "true";
      }

      getCurrentVariantId() {
        if (!this.variantIdInput || !this.variantIdInput.value) return null;
        var v = parseInt(this.variantIdInput.value, 10);
        if (isNaN(v)) return null;
        return v;
      }

      getInventoryRow(variantId) {
        if (!this.sectionId || !variantId) return null;

        var mapEl = document.getElementById("VariantInventoryMap-" + this.sectionId);
        if (!mapEl) return null;

        var arr = [];
        try {
          arr = JSON.parse(mapEl.textContent || "[]");
        } catch (e) {
          arr = [];
        }

        for (var i = 0; i < arr.length; i++) {
          var row = arr[i];
          if (!row) continue;
          if (parseInt(row.id, 10) === parseInt(variantId, 10)) return row;
        }
        return null;
      }

      getAvailableStock(variantId) {
        var row = this.getInventoryRow(variantId);
        if (!row) return null;

        if (!row.managed) return null;

        var qty = parseInt(row.qty, 10);
        if (isNaN(qty)) qty = 0;
        return qty;
      }

      applyStockLimitAndUi() {
        if (!this.quantityInput) return;

        if (this.isCustomizableProduct()) {
          this.updatePlusMinusState();
          return;
        }

        var variantId = this.getCurrentVariantId();
        if (!variantId) {
          this.updatePlusMinusState();
          return;
        }

        var stockQty = this.getAvailableStock(variantId);

        if (stockQty === null) {
          this.updatePlusMinusState();
          return;
        }

        this.quantityInput.setAttribute("max", String(stockQty));
        this.quantityInput.dataset.max = String(stockQty);

        var current = parseInt(this.quantityInput.value || "0", 10);
        if (isNaN(current)) current = 0;

        if (stockQty <= 0) {
          if (current !== 1) this.quantityInput.value = "1";
        } else if (current > stockQty) {
          this.quantityInput.value = String(stockQty);
        } else if (current < 1) {
          this.quantityInput.value = "1";
        }

        this.updatePlusMinusState();
      }

      setButtonDisabled(btn, disabled) {
        if (!btn) return;

        btn.disabled = !!disabled;

        if (disabled) {
          btn.setAttribute("aria-disabled", "true");
          btn.classList.add("is-disabled");
        } else {
          btn.removeAttribute("aria-disabled");
          btn.classList.remove("is-disabled");
        }
      }

      updatePlusMinusState() {
        if (!this.quantityInput) return;

        var val = parseInt(this.quantityInput.value || "0", 10);
        if (isNaN(val)) val = 0;

        var maxAttr = this.quantityInput.getAttribute("max");
        var maxVal = maxAttr !== null && maxAttr !== "" ? parseInt(maxAttr, 10) : null;
        if (maxVal !== null && isNaN(maxVal)) maxVal = null;

        var minAttr = this.quantityInput.getAttribute("min");
        var minVal = minAttr !== null && minAttr !== "" ? parseInt(minAttr, 10) : 1;
        if (isNaN(minVal)) minVal = 1;

        var shouldDisablePlus =
          !this.isCustomizableProduct() && maxVal !== null && val >= maxVal;

        this.setButtonDisabled(this.plusBtn, shouldDisablePlus);

        var shouldDisableMinus = val <= minVal;
        this.setButtonDisabled(this.minusBtn, shouldDisableMinus);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        var submitButton = this.querySelector('[type="submit"]');
        if (!submitButton || submitButton.classList.contains("loading")) return;

        this.handleErrorMessage();

        if (this.cartNotification && typeof this.cartNotification.setActiveElement === "function") {
          this.cartNotification.setActiveElement(document.activeElement);
        }

        if (!this.isCustomizableProduct() && this.quantityInput) {
          var variantId = this.getCurrentVariantId();
          var stockQty = variantId ? this.getAvailableStock(variantId) : null;

          if (typeof stockQty === "number") {
            var requested = parseInt(this.quantityInput.value || "0", 10);
            if (isNaN(requested)) requested = 0;

            if (stockQty <= 0) {
              this.handleErrorMessage("Ahora mismo no hay stock disponible para esta variante.");
              return;
            }

            if (requested > stockQty) {
              this.quantityInput.value = String(stockQty);
              this.updatePlusMinusState();
              this.handleErrorMessage("Solo quedan " + stockQty + " unidades en stock.");
              return;
            }
          }
        }

        submitButton.setAttribute("aria-disabled", "true");
        submitButton.classList.add("loading");

        var spinner = this.querySelector(".loading-overlay__spinner");
        if (spinner) spinner.classList.remove("hidden");

        var config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        var formData = new FormData(this.form);

        var renderTarget = this.cartDrawer || this.cartNotification;
        if (renderTarget && typeof renderTarget.getSectionsToRender === "function") {
          var sectionsToRender = renderTarget
            .getSectionsToRender()
            .map((section) => section.section || section.id);

          console.log("sections pedidas:", sectionsToRender);
          console.log("sections_url:", window.location.pathname);

          formData.append("sections", sectionsToRender);
          formData.append("sections_url", window.location.pathname);

          if (typeof renderTarget.setActiveElement === "function") {
            renderTarget.setActiveElement(document.activeElement);
          }
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log("respuesta cart/add:", response);
            console.log("respuesta.sections:", response.sections);
            console.log(
              "respuesta section keys:",
              response.sections ? Object.keys(response.sections) : "sin sections"
            );

            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }

            if (this.cartDrawer && typeof this.cartDrawer.renderContents === "function") {
              this.cartDrawer.renderContents(response);
              return;
            }

            if (this.cartNotification && typeof this.cartNotification.renderContents === "function") {
              this.cartNotification.renderContents(response);
              return;
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
            if (spinner) spinner.classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}